function Fiji({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_521_1181)">
      <path d="M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0038 16 0.00175 16 0C24.8365 0 32 7.1635 32 16Z" fill="#338AF3"/>
      <path d="M16 7.65222V13.0487L10.4348 7.65222H16Z" fill="#0052B4"/>
      <path d="M8.34785 16H13.0486L8.34785 9.73914L7.65222 14.6087L8.34785 16Z" fill="#0052B4"/>
      <path d="M15.9572 16H16C16 15.9856 16 15.9716 16 15.9572C15.9857 15.9715 15.9715 15.9857 15.9572 16Z" fill="#F0F0F0"/>
      <path d="M16 8.34781C16 5.5325 16 3.68781 16 0H15.9973C7.162 0.0015 0 7.16431 0 16H8.34781V11.2993L13.0486 16H15.9573C15.9716 15.9858 15.9858 15.9715 16.0001 15.9572C16.0001 14.8793 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z" fill="#F0F0F0"/>
      <path d="M8.09467 2.08691C5.59223 3.51185 3.51185 5.59223 2.08691 8.09467V16H6.26085V6.26098V6.26085H16C16 4.94442 16 3.69029 16 2.08691H8.09467Z" fill="#D80027"/>
      <path d="M16 14.0325L10.3155 8.3479H8.3479V8.34803L15.9999 16H16C16 16 16 14.6433 16 14.0325Z" fill="#D80027"/>
      <path d="M18.0869 10.4348V15.9999C18.0869 19.7274 22.9565 20.8695 22.9565 20.8695C22.9565 20.8695 27.826 19.7274 27.826 15.9999V10.4348L22.9565 9.04346L18.0869 10.4348Z" fill="#F3F3F3"/>
      <path d="M27.826 10.4348V8.3479H18.0869V10.4348H22.2607V14.6088H18.0869V16V16.0002L22.2607 16.0002V20.6563C22.6806 20.8048 22.9565 20.8697 22.9565 20.8697C22.9565 20.8697 23.2322 20.8049 23.652 20.6563V16.0002H27.826V16V14.6088H23.652V10.4348H27.826V10.4348Z" fill="#D80027"/>
    </g>
  </svg>

  `;

  return baseXml;
}

export default Fiji;
